import Login from './components/Site/Login';
import ProfileAluno from './components/Aluno/Profile';
import ProfileInstrutor from './components/Instrutor/Profile';
import ScheduleAluno from './components/Aluno/ScheduleAluno';
import Teorico from './components/Teorico/Teorico';
import ProductAluno from './components/Product/ProductAluno';
import NewSchedule from './components/Schedule/NewSchedule';
import Calendar from './components/Instrutor/Calendar';
import Home from './components/Site/Home';
import TestSync from './components/TestRequest/TestSync';
import CheckList from './components/CheckList/CheckList'

const routes = [
  { path: '/', component: Home },
  { path: '/login', component: Login },
  { path: '/instrutor/profile', component: ProfileInstrutor },
  { path: '/aluno/schedule', component: ScheduleAluno },
  { path: '/aluno/teorico', component: Teorico },
  { path: '/aluno/product', component: ProductAluno },
  { path: '/schedule/newschedule', component: NewSchedule },
  { path: '/instrutor/:cpf/calendar/servico/:idServico', component: Calendar },
  { path: '/aluno/profile', component: ProfileAluno },
  { path: '/test', component: TestSync },
  { path: '/checklist/checklist', component: CheckList }
];
export default routes;
